import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import InfoIcon from "@mui/icons-material/Info";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import "../MarkdownTable.css"; // スタイルを追加
import ReactMarkdown from "react-markdown";
import versionHistoryContent from "./versionHistory.md";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100%)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Header(props) {
  const { logout } = useAuth0();
  const [hover, setHover] = useState(false);

  // propsを受け取る
  const {
    userName,
    userEmail,
    cookies,
    setCookie,
    removeCookie,
    open,
    setOpen,
    common_color_navi,
    versionId,
    openVersion,
    setOpenVersion,
  } = props;

  const [currentRow, setCurrentRow] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event, target) => {
    setAnchorEl(event.currentTarget);
    setCurrentRow(target);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentRow(null);
  };

  // サイドバーの開閉設定
  const handleDrawerOpen = () => {
    const flag =
      open === "" ? (cookies.sideOpen === "true" ? !true : !false) : !open;
    setOpen(flag);
    setCookie("sideOpen", flag); // Cookie格納
  };
  // Version履歴ダイアログ閉じる
  const handleCloseVersionDialog = () => {
    setOpenVersion(false);
    handleClose();
  };

  // Version履歴情報取得
  const setVersionHistory = () => {
    return (
      <DialogContent dividers={true}>
        <Box>
          <ReactMarkdown>{versionHistoryContent}</ReactMarkdown>
        </Box>
      </DialogContent>
    );
  };

  return (
    <>
      <AppBar
        position="fixed"
        // open={open}
        sx={{
          backgroundColor: common_color_navi,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {hover ? (
              open ? (
                <ArrowBackIcon />
              ) : (
                <ArrowForwardIcon />
              )
            ) : open ? (
              <MenuOpenIcon />
            ) : (
              <MenuIcon />
            )}
          </IconButton>
          <Typography variant="h6" component="div" sx={{ ml: 1 }}>
            Smart Order Pro
          </Typography>
          <Typography
            variant="caption"
            component="div"
            sx={{ flexGrow: 1, ml: 1, mt: 1 }}
          >
            Ver {versionId}
          </Typography>
          <div>
            <IconButton
              aria-controls="setting-menu"
              aria-haspopup="true"
              onClick={(e) => handleMenu(e, "setting-menu")}
              color="inherit"
            >
              <InfoIcon />
            </IconButton>
            <Menu
              id="setting-menu"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={currentRow === "setting-menu"}
              onClose={() => handleClose()}
            >
              <MenuItem onClick={() => setOpenVersion(true)}>
                <ListItemIcon>
                  <UpdateOutlinedIcon fontSize="small" />
                </ListItemIcon>
                バージョン履歴
              </MenuItem>
              <MenuItem onClick={() => window.open("./manual.html", "_blank")}>
                <ListItemIcon>
                  <NoteAltOutlinedIcon fontSize="small" />
                </ListItemIcon>
                マニュアル
              </MenuItem>
            </Menu>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="account-menu"
              aria-haspopup="true"
              onClick={(e) => handleMenu(e, "account-menu")}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="account-menu"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={currentRow === "account-menu"}
              onClose={() => handleClose()}
            >
              <MenuItem>
                <ListItemIcon>
                  <AccountCircle fontSize="small" />
                </ListItemIcon>
                {userName}({userEmail})
              </MenuItem>
              <MenuItem
                onClick={() => {
                  removeCookie("isAdmin");
                  logout({ returnTo: window.location.origin });
                }}
              >
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Dialog
        open={openVersion}
        onClose={() => handleCloseVersionDialog()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        fullWidth={true}
        maxWidth="md"
      >
        {setVersionHistory()} {/* バージョン履歴 */}
        <DialogActions>
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{ mr: 1.5 }}
              onClick={() => handleCloseVersionDialog()}
            >
              閉じる
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}
